import classnames from 'classnames';
import React from 'react';
import { Icon } from "../icon/Icon.js";
import styles from "./Flag.module.js";

/**
 * @deprecated Please use the `InfoTag` Component fron `@platform/elements` instead.
 */
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/**
 * @deprecated Please use the `InfoTag` Component fron `@platform/elements` instead.
 */
export const Flag = ({
  icon,
  children,
  className,
  noBorder = false
}) => {
  const classes = classnames(styles.flag, !noBorder && styles.border, className);
  return /*#__PURE__*/_jsx("div", {
    className: classes,
    children: /*#__PURE__*/_jsxs("div", {
      children: [icon && /*#__PURE__*/_jsx(Icon, {
        icon: icon,
        className: children && styles.withLabel,
        size: 15
      }), /*#__PURE__*/_jsx("span", {
        children: children
      })]
    })
  });
};